function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRef } from 'react';
import { educationPeriodDateSpread } from '../../date';
import styles from '../../../sass/navigation.module.scss';
export default (function (_ref) {
  var selectedEducationPeriod = _ref.selectedEducationPeriod,
    _ref$availableEducati = _ref.availableEducationPeriods,
    availableEducationPeriods = _ref$availableEducati === void 0 ? {} : _ref$availableEducati,
    selectYearAction = _ref.selectYearAction,
    unsavedForm = _ref.unsavedForm,
    unsavedChangesModal = _ref.unsavedChangesModal,
    onRoleChange = _ref.onRoleChange,
    openModal = _ref.openModal,
    style = _ref.style;
  var linkRef = useRef(null);
  var available = [];
  if (Object.keys(availableEducationPeriods).length) {
    available = Object.keys(availableEducationPeriods).map(function (edpdCode) {
      return _objectSpread(_objectSpread({}, availableEducationPeriods[edpdCode]), {}, {
        date: educationPeriodDateSpread(availableEducationPeriods[edpdCode].academicYrStartDate, availableEducationPeriods[edpdCode].academicYrEndDate)
      });
    });
  }
  function switchAcademicYear(code) {
    selectYearAction(code);
    if (onRoleChange) onRoleChange();
  }
  function selectAcademicYear(code, e) {
    var localSwitchAcademicYear = switchAcademicYear.bind(this, code);
    e.preventDefault();
    if (!code) return;
    if (unsavedForm) {
      openModal(unsavedChangesModal, {
        form: unsavedForm,
        callback: localSwitchAcademicYear,
        saveButtonText: 'Save & Continue',
        onSuccessAction: localSwitchAcademicYear,
        modalCloseFocusElem: linkRef.current
      });
    } else switchAcademicYear(code);
  }
  function academicYearMenuItem(educationPeriod) {
    var code = educationPeriod.code,
      date = educationPeriod.date;
    if (code.toString() === selectedEducationPeriod.toString()) return null;
    return /*#__PURE__*/React.createElement("li", {
      key: code,
      className: "edperiod-item",
      role: "presentation"
    }, /*#__PURE__*/React.createElement("a", {
      role: "menuitem",
      href: "#",
      onClick: function onClick(e) {
        return selectAcademicYear(code, e);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Select this academic year: "), date));
  }
  function selectAcademicYearDropdown(style) {
    var displayDate = available.find(function (ep) {
      return ep.code.toString() === selectedEducationPeriod.toString();
    }).date;
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown cb-dropdown ".concat(styles['select-academic-year']),
      style: style
    }, /*#__PURE__*/React.createElement("a", {
      className: "dropdown-toggle",
      style: {
        color: '#0077c8'
      },
      "aria-haspopup": true,
      "aria-current": true,
      "data-toggle": "dropdown",
      href: "#",
      id: "dropdownMenuAcademicYearSelection",
      role: "button",
      ref: linkRef
    }, /*#__PURE__*/React.createElement("span", {
      className: "roboto-slab-bold"
    }, displayDate), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Press Enter for Dropdown."), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-down",
      style: {
        marginLeft: '6px'
      },
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("i", {
      className: "cb-glyph cb-up hidden",
      style: {
        marginLeft: '6px'
      },
      "aria-hidden": "true"
    })), /*#__PURE__*/React.createElement("ul", {
      className: "dropdown-menu",
      role: "menu",
      "aria-labelledby": "dropdownMenuAcademicYearSelection"
    }, available.map(function (edpd) {
      return academicYearMenuItem(edpd);
    })));
  }
  if (available.length > 1 && selectedEducationPeriod) return selectAcademicYearDropdown(style);
  if (available.length === 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['select-academic-year'],
      style: style
    }, available[0].date);
  }
  return null;
});